module.exports = __webpack_public_path__ + "img/compv2.2b1d5431.webp";